import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import LiveEventsSection from './components/LiveEventsSection';
import CategorySection from './components/CategorySection';
import FeaturesSection from './components/FeaturesSection';
import UpcomingSection from './components/UpcomingSection';
import ArticlePreviewSection from './components/ArticlePreviewSection';
import FaqSection from './components/FaqSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'bob体育',
    url: 'https://www.bob-sports.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.bob-sports.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'bob体育如何注册账号？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '点击页面右上角"注册"按钮，填写手机号或邮箱，设置密码，完成短信或邮箱验证即可成功注册bob体育账号。整个注册过程仅需1分钟。',
        },
      },
      {
        '@type': 'Question',
        name: 'bob体育支持哪些充值方式？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'bob体育支持多种充值方式，包括银行卡转账、支付宝、微信支付、USDT数字货币等。充值实时到账，不收取任何手续费。',
        },
      },
      {
        '@type': 'Question',
        name: '提现需要多长时间到账？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'bob体育提现审核通常在30分钟内完成，审核通过后，银行卡提现1-3个工作日到账，数字货币提现实时到账。VIP用户享受优先处理通道。',
        },
      },
      {
        '@type': 'Question',
        name: 'bob体育赔率是否具有竞争力？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'bob体育采用国际顶级赔率系统，赔率实时对标全球主流博彩市场，确保为用户提供极具竞争力的赔率。',
        },
      },
      {
        '@type': 'Question',
        name: 'bob体育App如何下载？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以在bob体育官网首页找到App下载入口，支持iOS和Android双平台。',
        },
      },
    ],
  };

  return (
    <>
      <SchemaOrg data={websiteSchema} />
      <SchemaOrg data={faqSchema} />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20at%20night%20with%20dramatic%20floodlights%20and%20electric%20atmosphere%2C%20professional%20sports%20photography%2C%20dark%20moody%20background%20with%20warm%20golden%20and%20crimson%20accents%2C%20abstract%20artistic%20style%2C%20energy%20and%20excitement%2C%20no%20text%20no%20logos&width=1800&height=900&seq=hero-bob-sports-main&orientation=landscape"
            alt="bob体育 - 专业在线体育娱乐平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <div className="max-w-3xl mx-auto">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-tight leading-tight">
                专业体育竞猜平台
              </h1>
              <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
                覆盖足球、篮球、网球等全球顶级赛事，实时赔率更新，多种投注方式任你选择，bob体育与你共享竞猜激情。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="#"
                  className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  立即注册
                </a>
                <Link
                  to="/category/football"
                  className="w-full sm:w-auto px-8 py-3.5 rounded-lg border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-colors whitespace-nowrap"
                >
                  查看赛事
                </Link>
              </div>

              <div className="flex items-center justify-center gap-6 mt-8">
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-white">500万+</div>
                  <div className="text-xs text-white/60 mt-1">注册用户</div>
                </div>
                <div className="w-px h-10 bg-white/20"></div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-white">200+</div>
                  <div className="text-xs text-white/60 mt-1">覆盖赛事</div>
                </div>
                <div className="w-px h-10 bg-white/20"></div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-white">7×24h</div>
                  <div className="text-xs text-white/60 mt-1">在线客服</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <LiveEventsSection />
        <CategorySection />
        <FeaturesSection />
        <UpcomingSection />
        <ArticlePreviewSection />
        <FaqSection />

        {/* CTA Section */}
        <section className="relative py-16 md:py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20action%20collage%20with%20soccer%20basketball%20tennis%20elements%2C%20dark%20dramatic%20background%20with%20golden%20and%20crimson%20light%20streaks%2C%20abstract%20artistic%20style%2C%20energy%20and%20motion%2C%20premium%20sports%20aesthetic%2C%20no%20text%20no%20logos&width=1800&height=600&seq=cta-bob-sports&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3">
              即刻加入 bob体育
            </h2>
            <p className="text-sm md:text-base text-white/70 mb-8 max-w-lg mx-auto">
              注册即享专属欢迎礼包，开启您的专业竞猜之旅
            </p>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-lg bg-accent-500 text-foreground-950 font-semibold text-sm hover:bg-accent-400 transition-colors whitespace-nowrap"
            >
              免费注册 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}